import cn from 'classnames'
import React, { useEffect } from 'react'
import ImageElement from '../imageelement/ImageElement'
import VideoElement from '../videoelement/VideoElement'
import config from '../../config.json'

export const AssetPreviewDisplay = ({
    asset,
    className = cn(''),
    imgClassName = cn('max-h-full'),
    previewDuration = 1,
    useGradient = true,
    grayScale = false,
    fetchPriority = 'low',
    disableAspectRatio,
    currentAsset,
}) => {
    let { name, collection, mutableData, image, backImg, video } = asset

    useEffect(() => {}, [currentAsset])

    let prevImg = ''

    if (!image && mutableData) {
        try {
            const data = JSON.parse(mutableData)
            for (let imgName of ['Image', 'Front', 'Display', 'Cover']) {
                if (data && Object.keys(data).includes(imgName)) {
                    image = data[imgName]
                }
            }
        } catch (e) {}
    }

    if ((image || video) && collection) {
        prevImg = config.ipfspreviewhash
            .replaceAll(
                '{collection}',
                collection?.collectionName
                    ? collection?.collectionName
                    : collection,
            )
            .replaceAll('{hash}', video ? video : image)
            .replaceAll('{size}', '240')
    }

    return (
        <div className={'w-full h-full'}>
            {video && (!prevImg || !prevImg.includes('preview?collection')) ? (
                <VideoElement
                    className={cn(imgClassName, { grayscale: grayScale })}
                    image={prevImg}
                    backimg={backImg}
                    video={prevImg ? prevImg : video}
                    autoPlay={true}
                    timeout={previewDuration * 1000}
                    useGradient={useGradient}
                    fetchPriority={fetchPriority}
                />
            ) : prevImg || image ? (
                <ImageElement
                    name={name}
                    src={prevImg ? prevImg : image}
                    useThumbnail={prevImg !== undefined}
                    className={className}
                    imgClassName={cn('', imgClassName, {
                        grayscale: grayScale,
                    })}
                    useGradient={useGradient}
                    fetchPriority={fetchPriority}
                    disableAspectRatio={disableAspectRatio}
                />
            ) : null}
        </div>
    )
}

export default AssetPreviewDisplay
